import request from '@/utils/request'

/**
 * 歸檔任務列表
 * @param {*} data
 */
export function workTaskArchListAPI(data) {
  return request({
    url: 'work/task/archList',
    method: 'post',
    data: data
  })
}

/**
 * 專案詳情
 * @param {*} data
 */
export function workWorkReadAPI(data) {
  return request({
    url: 'work/work/read',
    method: 'post',
    data: data
  })
}

/**
 * 專案刪除
 * @param {*} data
 */
export function workWorkDeleteAPI(data) {
  return request({
    url: 'work/work/delete',
    method: 'post',
    data: data
  })
}

/**
 * 新建專案
 * @param {*} data
 */
export function workWorkSaveAPI(data) {
  return request({
    url: 'work/work/save',
    method: 'post',
    data: data
  })
}

/**
 * 退出專案
 * @param {*} data
 */
export function workWorkLeaveAPI(data) {
  return request({
    url: 'work/work/leave',
    method: 'post',
    data: data
  })
}

/**
 * 任務板列表
 * @param {*} data
 */
export function workTaskIndexAPI(data) {
  return request({
    url: 'work/task/index',
    method: 'post',
    data: data
  })
}

/**
 * 歸檔專案
 * @param {*} data
 */
export function workWorkArchiveAPI(data) {
  return request({
    url: 'work/work/archive',
    method: 'post',
    data: data
  })
}

/**
 * 新建分類列表
 * @param {*} data
 */
export function workTaskclassSaveAPI(data) {
  return request({
    url: 'work/taskclass/save',
    method: 'post',
    data: data
  })
}

/**
 * 分類重新命名
 * @param {*} data
 */
export function workTaskclassRenameAPI(data) {
  return request({
    url: 'work/taskclass/rename',
    method: 'post',
    data: data
  })
}

/**
 * 分類刪除
 * @param {*} data
 */
export function workTaskclassDeleteAPI(data) {
  return request({
    url: 'work/taskclass/delete',
    method: 'post',
    data: data
  })
}

/**
 * 獲取附件列表
 * @param {*} data
 */
export function workWorkFileListAPI(data) {
  return request({
    url: 'work/work/fileList',
    method: 'post',
    data: data
  })
}

/**
 * 專案 -- 基礎設定
 * @param {*} data
 */
export function workWorkUpdateAPI(data) {
  return request({
    url: 'work/work/update',
    method: 'post',
    data: data
  })
}

/**
 * 專案 -- 成員列表
 * @param {*} data
 */
export function workWorkOwnerListAPI(data) {
  return request({
    url: 'work/work/ownerList',
    method: 'post',
    data: data
  })
}

/**
 * 專案 -- 成員新增
 * @param {*} data
 */
export function workWorkOwnerAddAPI(data) {
  return request({
    url: 'work/work/ownerAdd',
    method: 'post',
    data: data
  })
}

/**
 * 專案 -- 成員刪除
 * @param {*} data
 */
export function workWorkOwnerDelAPI(data) {
  return request({
    url: 'work/work/ownerDel',
    method: 'post',
    data: data
  })
}

/**
 * 專案 -- 歸檔已完成任務
 * @param {*} data
 */
export function workTaskArchiveTaskAPI(data) {
  return request({
    url: 'work/task/archiveTask',
    method: 'post',
    data: data
  })
}

/**
 * 拖拽改變分類
 * @param {*} data
 */
export function workTaskUpdateOrderAPI(data) {
  return request({
    url: 'work/task/updateOrder',
    method: 'post',
    data: data
  })
}

/**
 * 拖拽改變分類列表
 * @param {*} data
 */
export function workTaskUpdateClassOrderAPI(data) {
  return request({
    url: 'work/task/updateClassOrder',
    method: 'post',
    data: data
  })
}

/**
 * 專案成員新增角色
 * @param {*} data
 */
export function workWorkAddUserGroupAPI(data) {
  return request({
    url: 'work/work/addUserGroup',
    method: 'post',
    data: data
  })
}

/**
 * 專案成員角色列表
 * @param {*} data
 */
export function workWorkGroupListAPI(data) {
  return request({
    url: 'work/work/groupList',
    method: 'post',
    data: data
  })
}
